import { gql } from '@lojinha/palantir'

export const GET_PROFILE_DATA = gql`
  query GetProfileInfo {
    viewer {
      user {
        id
        name
        email
        phoneNumber
        cpf
      }
    }
  }
`

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUserProfile($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        name
        phoneNumber
        cpf
      }
    }
  }
`

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      success
    }
  }
`
